// extracted by mini-css-extract-plugin
export default {"zoomModal":"P2-z","image":"Q2-z","button":"R2-z","isOverlayShown":"S2-z"};